// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","noDecor":"G19f174 G66772c","base":"Gf7b7cb G5f506e G66772c G9e2e85","secondary":"G5314ec"};